import Vue from "vue";
import VueRouter from "vue-router";

// 引入组件
 import notsure from "./components/NotSure.vue";
 import speaker from "./components/Speaker.vue";
 import attendee from "./components/Attendee.vue";
 import speaker_noemail from "./components/Speaker_noemail.vue";
  import Digitalcitycongress from "./components/Digitalcitycongress.vue";
 import succeed from "./components/Succeed.vue";
 import succSpeaker from "./components/SuccSpeaker.vue";
 import succAttendee from "./components/SuccAttendee.vue";
 import attendeeOne from "./components/AttendeeOne.vue";
// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);

const router = new VueRouter({
    // mode:"history",  //去除地址#号
    routes:[
    //打包的时候路由为  “/” 即是打包页面，
    //不确定 
    {
        path:"/notsure",
        name: 'notsure',
        component: notsure
    },
    //演讲者
    {
        path:"/speaker",
        name:'speaker',
        component: speaker
    },
    //报名页面
    {
        path:"/speaker_noemail",
        name:'speaker_noemail',
        component: speaker_noemail
    },
    //数字城市大会报名页面
    {
        path:"/",
        name:'Digitalcitycongress',
        component: Digitalcitycongress
    },
    //出席者
    { 
        path:"/attendee",
        name: 'attendee',
        component: attendee
    },
    //成功页面
    {
        path:"/succeed",
        name: 'succeed',
        component: succeed
    },
    //成功页面
    {
        path:"/succSpeaker",
        name: 'succSpeaker',
        component: succSpeaker
    },
    //成功页面
    {
        path:"/succAttendee",
        name: 'succAttendee',
        component: succAttendee
    },

    //2021添加
    //演讲者
    { 
        path:"/",
        name: 'attendeeOne',
        component: attendeeOne
    },

]
})

export default router;


// WEBPACK FOOTER //
// ./src/router.js